import { translateUi } from "@i18n/config"; /**
 * Format a full name from first and last name components
 * Ensures proper spacing and handles edge cases
 */
export function formatFullName(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();

  if (!first && !last) return "";
  if (!first) return last;
  if (!last) return first;

  return translateUi("value0Value1Interpolated", "{{value0}} {{value1}}", {
    value0: first,
    value1: last,
  });
}

/**
 * Parse a full name into first and last name components
 * This is a simple implementation that splits on the first space
 */
export function parseFullName(fullName?: string | null): {
  firstName: string;
  lastName: string;
} {
  const name = (fullName || "").trim();

  if (!name) return { firstName: "", lastName: "" };

  const parts = name.split(" ");
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" };
  }

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(" "),
  };
}
